import { Select } from 'antd';
import React, { useState, useEffect } from 'react';

const monthNames = {
  'en-US': [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  'pt-BR': [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  'es-ES': [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
};

const SelectMonthYear = ({ language = 'en', onChange, value, maxDate }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const startDate = new Date(maxDate);
    startDate.setDate(1); // Set to first day of month
    const endDate = new Date();
    endDate.setDate(1); // Set to first day of month

    const allMonths = [];
    const cursor = new Date(startDate);

    while (
      cursor.getFullYear() < endDate.getFullYear() ||
      (cursor.getFullYear() === endDate.getFullYear() &&
        cursor.getMonth() <= endDate.getMonth())
    ) {
      allMonths.push(new Date(cursor));
      cursor.setMonth(cursor.getMonth() + 1);
    }

    const recentMonths = allMonths.slice(-24);
    const months = recentMonths.map((date) => {
      const year = date.getFullYear();
      const month = date.getMonth();
      const value = `${year}-${String(month + 1).padStart(2, '0')}`;
      return {
        value,
        label: `${monthNames[language][month]} ${year}`,
      };
    });

    setOptions(months);
  }, [language, maxDate]);

  return (
    <Select
      size="large"
      style={{ minWidth: 200 }}
      value={value}
      options={options}
      onSelect={onChange}
    />
  );
};

export default SelectMonthYear
